<template>
  <div>
    <!-- <div style="height:57px;" class="row comm-settings-top-nav">
      <div class="col-md-10 justify-content-start" style="position:relative">
        <back-button v-if="componentname != 'show-custom-metadatas'" v-on:click.native="changeToSelectedCustomMetadataTableComponent('show-custom-metadatas')" style="position: absolute;bottom: 19px;inset-inline-start:15px;"></back-button>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb comm-settings-top-nav m-0" style="padding-inline-start:4%">
            <li class="breadcrumb-item"><a v-on:click="changeToSelectedCustomMetadataTableComponent('show-custom-metadatas')">Fields</a></li>
            <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{selectedCustomKeyName}}</li>
            </ol>
        </nav>
      </div>
      <div class="col-2 p-0 primary-btn-style justify-content-end">
          <button type="button" class="btn btn-outline-primary" v-if="showAddCustomKeyButton" v-on:click="changeToSelectedCustomMetadataTableComponent('add-custom-metadata')">Add</button>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
    props : ["selectedCustomKeyName","showAddCustomKeyButton","componentname"],
    data(){
        return{
            add:"Add",
        }
    },
    components: {
  },
    methods:{
        changeToSelectedCustomMetadataTableComponent(compName, payload = {}){
            this.$emit("changeToSelectedCustomMetadataTableComponent", compName, payload)
        }
    }
}
</script>

<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$active-blue : #007bff;


.comm-settings-top-nav{
    background: transparent;
}

.btn{
    height:100%;
}

.breadcrumb{
  padding: .75rem 1rem !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.primary-btn-style{
    margin-top:1%;
    button{
        height: 35px;
        width: 70px;
        float: inline-end;
        margin-inline-end: 25px;
    font-size:14px;
    }
}
</style>